<template>
  <div class="screen" :class="classname">
    <!--<img :src="imageUri"/>-->
    <digital-clock blink="true"/>    

    <div v-if="current">
      <div class="text delegate" v-if="current.delegate">
        <fit-text v-if="fitDelegate">{{current.delegate}}</fit-text>
        <span v-else>{{current.delegate}}</span>
      </div>
      <div class="text association" v-if="current.association">
        <fit-text v-if="fitAssociation">{{current.association}}</fit-text>
        <span v-else>{{current.association}}</span>
      </div>
      <!--
      <div class="text delegate-and-association" v-if="delegateAndAssociation">
        <fit-text v-if="fitDelegateAndAssociation">{{delegateAndAssociation}}</fit-text>
        <span v-else>{{delegateAndAssociation}}</span>
      </div>
    -->
      <div class="text motion" v-if="current.motion">
        <fit-text v-if="fitMotion">{{current.motion}}</fit-text>
        <span v-else>{{current.motion}}</span>
      </div>
    </div>
    <div class="speakers" v-if="showSpeakers">
      <h4>Next Speakers</h4>
      <speakers-list-compact :screen="which"/>
    </div>
  </div>
</template>

<script>
import cron from '../../mixins/cron'
import DigitalClock from 'vue-digital-clock'
import FitText from '../text/FitText.vue'
import SpeakersListCompact from '../speakers/SpeakersListCompact.vue'
import NeuLogo from '../branding/NeuLogo.vue'

export default {
  name: 'OnScreen',
  mixins: [
    cron
  ],
  components: {
    DigitalClock,
    FitText,
    SpeakersListCompact,
    NeuLogo
  },
  computed: {
    which () {
      return this.$route.params['which']
    },
    classname () {
      return this.$route.params['which'] === 'two' ? 'screen-1280' : 'screen-3072'
    },
    imageUri () {
      return ''
      // return this.$route.params['which'] === 'two' ? '/static/img/2026/2026-16-9.png' : '/static/img/2026/bg-2026.png'
    },
    current () {
      return this.$store.getters['screens/current']
    },
    delegateAndAssociation () {
      if (this.current === null) {
        return null
      }
      const hasDelegate = (this.current.delegate.delegate !== null && this.current.delegate !== '')
      const hasAssociation = (this.current.association !== null && this.current.association !== '')
      if (hasDelegate && hasAssociation) {
        return this.current.delegate + ', ' + this.current.association
      }
      if (hasDelegate && !hasAssociation) {
        return this.current.delegate
      }
      if (hasAssociation && !hasDelegate) {
        return this.current.association
      }
      return null
    },
    refreshRate () {
      return this.$store.getters['screens/refreshRate']
    },
    showSpeakers () {
      if (!this.$store.getters['settings/showSpeakersOnScreen']) {
        return false
      }
      console.log(this.current)
      if (this.current === null) {
        return false
      }
      if (this.current.motion === null || this.current.motion === '') {
        return false
      }
      return true
      /**
      if (!this.current) {
        return false
      }
      const hasMotion = (this.current.motion !== null && this.current.motion !== '')
      console.log(this)
      if (!this.current) {
        return false
      }
      if (!this.current.motion) {
        return false
      }
      if (this.current.motion === '') {
        return false
      }
      if (this.motion.state !== MotionState.ACTIVE) {
        return false
      }
      return true
      return true
      return this.$store.getters['settings/showSpeakersOnScreen']
      return this.$route.params['which'] === 'two' ? this.$store.getters['motions/showSpeakersOnScreenTwo']
        : this.$store.getters['motions/showSpeakersOnScreen']
        **/
    },
    fitMotion () {
      if (!this.current || !this.current.motion) {
        return false
      }
      return this.current.motion.length > 50
    },
    fitDelegate () {
      if (!this.current || !this.current.delegate) {
        return false
      }
      return this.current.delegate.length > 18
    },
    fitAssociation () {
      if (!this.current || !this.current.association) {
        return false
      }
      return this.current.association.length > 18
    },
    fitDelegateAndAssociation () {
      if (!this.current || !this.delegateAndAssociation) {
        console.log('one not set, not auto')
        return false
      }
      return this.delegateAndAssociation.length > 50
    }
  },
  async created () {
    this.$store.dispatch('screens/load')
  },
  async mounted () {
    this.$cron.time('reload', this.refreshRate)
  },
  watch: {
    refreshRate () {
      this.$cron.time('reload', this.refreshRate)
    }
  },
  methods: {
    reload () {
      console.log('reloading')
      this.$store.dispatch('screens/load')
    }
  },
  cron: [
    {
      time: 60000,
      method: 'reload'
    }
  ]
}
</script>

<style scoped>
.screen {
  font-family: rubik_bold;
  position: relative;
}

.screen-3072 {
  width: 3328px;
  height: 896px;
}

.screen-3072 .text {
  font-family: rubik_bold;
  font-size: 58px;
  /** border: solid 1px red; **/
}
.screen-3072 .text.delegate, .screen-3072 .text.association {
  font-size: 46px;
  font-weight: bold;
}
.screen-3072 .text.delegate {
  left: 30px;
  top: 35px;
  width: 490px;
  height: 80px;
}
.screen-3072 .text.association {
  left: 30px;
  top: 100px;
  width: 520px;
  height: 80px;
  line-height: 2.35rem;
}
.screen-3072 .text.delegate-and-association {
  left: 20px;
  top: 40px;
  width: 1300px;
  height: 70px;
}
.screen-3072 .text.motion {
  left: 30px;
  top: 265px;
  width: 730px;
  height: 130px;
  font-size: 48px;
  color: #645dc7;
  font-weight: bold;
}

.screen-3072 .speakers {
  top: 400px;
  left: 35px;
  width: 800px;
  height: 300px;
  font-size: 30px;
  /** border: solid 1px red; **/
}
.screen-3072 .speakers h4 {
  color: #009db0;
  margin-top: 0;
  margin-bottom: 0.5rem;
}
.screen-3072 .speakers .opinion {
  font-size: 40px;
}
.screen-3072 .clock {
  font-family: rubik_bold;
  color: #f7941d;
  left: 3150px;
  top: 800px;
  font-size: 48px !important;
  height: 50px;
  font-weight: bold;
}

.screen-1920 {
  width: 1920px;
  height: 1080px;
}

.screen img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}
.screen-1280 {
  width: 1920px;
  height: 1080px;
}
.clock, .text, .speakers {
  position: absolute;
  color: white;
}
.text {
  /** background: #222222; **/
  text-align: left;
}
.screen-1920 .text {
  font-size: 58px;
}
.screen-1280 .text {
  color: #111;
  font-size: 48px;
  /** border: solid 1px red; **/
}
.screen-1280 .text.delegate, .screen-1280 .text.association {
  font-size: 48px;
  font-weight: bold;
  color: white;
}
.screen-1280 .text.delegate {
  left: 35px;
  top: 910px;
  width: 670px;
  height: 70px;
}
.screen-1280 .text.association {
  left: 35px;
  top: 980px;
  width: 670px;
  height: 70px;
}
.screen-1280 .text.motion {
  left: 35px;
  top: 800px;
  width: 1600px;
  height: 80px;
  color: #645dc7;
  font-weight: bold;
}
.screen-1280 .speakers {
  color:  #111;
  top: 490px;
  left: 1308px;
  width: 590px;
  height: 300px;
  font-size: 36px;
  /** border: solid 1px red; **/
}
.screen-1280 .speakers h4 {
  color: #111;
  margin-top: 0;
  margin-bottom: 0.5rem;
}
.screen-1280 .clock {
  color: #f7941d;
  left: 1760px;
  top: 1000px;
  font-size: 36px !important;
  font-weight: bold;
}

.screen-1920 .text.delegate {
  left: 30px;
  bottom: 60px;
  width: 1650px;
  height: 80px;
}
.screen-1920 .text.association {
  left: 470px;
  bottom: 260px;
  width: 1850px;
  height: 120px;
}
.screen-1920 .text.delegate-and-association {
  left: 80px;
  top: 40px;
  width: 1300px;
  height: 70px;
}
.screen-1920 .text.motion {
  left: 80px;
  top: 110px;
  width: 1600px;
  height: 80px;
}
.screen .speakers {
  overflow: hidden;
  color: white;
}
.screen-1920 .speakers {
  top: 665px;
  left: 65px;
  width: 725px;
  height: 320px;
  font-size: 48px;
}
.screen-1920 .speakers .opinion {
  font-size: 40px;
}

.clock {
  font-size: 60px;
  font-weight: bold;
  top: 230px;
  left: 115px;
}
.screen-1280 .clock {
  font-size: 30px;
}
.neu-logo {
  position: absolute;
  top: 270px;
  left: -5px;
}
</style>



// WEBPACK FOOTER //
// src/components/screen/OnScreen.vue